import { createActionConst } from '../../../utils/action.utils';

const TIME_TRACKING_PAGE_NAMESPACE = 'TIME_TRACKING_PAGE';

export const INITIAL_TIME_TRACKING_PAGE = createActionConst(TIME_TRACKING_PAGE_NAMESPACE, 'INITIAL_TIME_TRACKING_PAGE');
